import { MESSAGE_TYPES, type MessageResponse, SENDER_TYPES } from '@/entities/conversations';

/** Вид элемента переписки: по нему выбираются подпись над облаком и цвета облака */
export type FeedItemKind = 'employee' | 'client' | 'system' | 'note' | 'rule';

/** Оформление элемента переписки своего вида */
type FeedItemView = {
  /** Ключ перевода подписи вида над облаком */
  labelKey: string;
  /** Заливка подписи — параметр цвета темы блока «Чат» */
  labelClassName: string;
  /** Заливка облака; у сообщений клиента и сотрудника — фон самой ленты */
  bubbleClassName: string;
  /** Рядом с подписью показывается имя участника, если он известен */
  hasSender: boolean;
};

/** Оформление элементов переписки по видам */
export const FEED_ITEM_VIEWS = {
  employee: {
    labelKey: 'dialogs:textFeed.employee',
    labelClassName: 'bg-(--color-chat-label-employee)',
    bubbleClassName: 'bg-card',
    hasSender: true,
  },
  client: {
    labelKey: 'dialogs:textFeed.client',
    labelClassName: 'bg-(--color-chat-label-client)',
    bubbleClassName: 'bg-card',
    hasSender: true,
  },
  system: {
    labelKey: 'dialogs:textFeed.system',
    labelClassName: 'bg-(--color-chat-label-system)',
    bubbleClassName: 'bg-(--color-chat-cloud-system)',
    hasSender: false,
  },
  note: {
    labelKey: 'dialogs:textFeed.note',
    labelClassName: 'bg-(--color-chat-label-note)',
    bubbleClassName: 'bg-(--color-chat-cloud-note) italic',
    hasSender: true,
  },
  rule: {
    labelKey: 'dialogs:textFeed.rule',
    labelClassName: 'bg-(--color-chat-label-rule)',
    bubbleClassName: 'bg-(--color-chat-cloud-rule)',
    hasSender: false,
  },
} as const satisfies Record<FeedItemKind, FeedItemView>;

/**
 * Вид сообщения по отправителю: сотрудник и клиент — свои, системное сообщение, ответ бота
 * и сообщение без отправителя — системные.
 */
export const getMessageFeedItemKind = (message: MessageResponse): FeedItemKind => {
  if (message.senderType === SENDER_TYPES.EMPLOYEE) return 'employee';
  if (message.senderType === SENDER_TYPES.CLIENT) return 'client';
  return 'system';
};

/** Элемент переписки — событие правила или виджет: оба показываются облаком правила */
export const isRuleFeedItem = (message: MessageResponse): boolean =>
  message.type === MESSAGE_TYPES.RULE || message.type === MESSAGE_TYPES.WIDGET;
